// Phase 25 iter-17 (Lote B, M14) — web EUDR client.
//
// Wraps `GET /eudr/dds/received` for the BUYER view. The seller side
// (POST /eudr/dds) stays mobile-only because animals are managed there.

import { API_VERSION_PREFIX, type ReceivedDdsListResponse } from '@leyrochain/shared';

import { apiClient } from './client';

export async function listReceivedDds(): Promise<ReceivedDdsListResponse> {
  const { data } = await apiClient.get<ReceivedDdsListResponse>(
    `${API_VERSION_PREFIX}/eudr/dds/received`,
  );
  return data;
}
